import { useEffect } from 'react';
import { lockScroll } from './scrollLock.js';

/**
 * Pin the page while `active`. Takes a flag rather than being called from inside a condition,
 * because a hook cannot be — and because every overlay in this app is a `&&` inside a screen that
 * is mounted the whole time, not a component that appears.
 */
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    return lockScroll();
  }, [active]);
}
